import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import clsx from 'clsx'
import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { Material } from './materials'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      width: '85%',
      color: '#000026',

      '& .MuiSelect-icon': {
        marginRight: '8px',
      },

      '& .MuiOutlinedInput-notchedOutline': {
        border: '1px solid #000026',
      },
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    menuItemContent: {
      display: 'flex',
      width: '100%',
    },
    itemLineHeight: {
      lineHeight: '30px',
    },
    bestseller: {
      marginRight: '16px',
    },
    materialName: {
      marginLeft: '8px',
    },
  })
)

declare const SI_API_URL: string

interface IMaterialChooserProps {
  allMaterials: Record<string, Material>
  chosenMaterial: string
  onClick: () => void
}

const MaterialChooser = (props: IMaterialChooserProps) => {
  const classes = useStyles()

  const { t } = useTranslation('PricingCalculator')
  const { t: tMaterials } = useTranslation('common:materials')

  if (
    props.chosenMaterial === '' ||
    Object.keys(props.allMaterials).length === 0
  ) {
    return null
  }

  return (
    <FormControl variant="outlined" className={classes.formControl}>
      <Select
        data-pricingcalculator-element={'material-id'}
        data-pricingcalculator-materialid={props.chosenMaterial}
        value={props.chosenMaterial}
        onOpen={(evt) => {
          evt.preventDefault()
          props.onClick()
        }}
      >
        {Object.entries(props.allMaterials).map(
          ([materialId, { bestseller }]) => {
            return (
              <MenuItem
                key={materialId}
                selected={materialId === props.chosenMaterial}
                value={materialId}
              >
                <div className={classes.menuItemContent}>
                  <span
                    className={clsx(
                      classes.itemLineHeight,
                      classes.materialName
                    )}
                  >
                    {tMaterials(`${materialId}.name`)}
                  </span>{' '}
                  {bestseller && (
                    <>
                      <span className={'si-expander'}></span>
                      <span
                        className={clsx(
                          'si-text-caption',
                          classes.bestseller,
                          classes.itemLineHeight
                        )}
                      >
                        {t('material-chooser-bestseller')}
                      </span>
                    </>
                  )}
                </div>
              </MenuItem>
            )
          }
        )}
      </Select>
    </FormControl>
  )
}

export default MaterialChooser
